export const actionType = {
    MYTRIPS_REQUEST: 'MYTRIPS_REQUEST',
    MYTRIPS_SUCCESS: 'MYTRIPS_SUCCESS',
    MYTRIPS_FAILURE: 'MYTRIPS_FAILURE', 

    ADD_TRIP : 'ADD_TRIP'

    
};